import { defineComponent as _defineComponent } from 'vue'
import Info from '@/components/DynamicInfo.vue';
import TabelaLocalizacao from './TabelaLocalizacao.vue';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { useVuetify } from '@/composables/useVuetify';
import { TipoObra } from '@/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'CamposCapitulo',
  setup(__props) {

const vuetify = useVuetify();
const store = ConsultaObrasStore();
const { obraTempImpressao: obra } = storeToRefs(store);

return { __sfc: true,vuetify, store, obra, Info, TabelaLocalizacao, TipoObra }
}

})